export enum GeoAccuracy {
  UNKNOWN = 0,
  ROOFTOP = 1,
  RANGE_INTERPOLATED = 2,
  GEOMETRIC_CENTER = 3,
  APPROXIMATE = 4,
}
